import { BLOCK_NAME } from '../image-carousel';

/**
 * Creates optional next/previous arrow buttons for slick carousel.
 * @param {string} element - BEM element name within image-carousel
 * @param {string} title - Title text and aria-label for svg icon
 * @param {string} svg - File name of the svg
 * @return {string} - HTML for button element
 */
export default function slickArrow(element, title, svg) {
  if (svg === 'arrow-right') {
    return `
      <button type="button" class="${BLOCK_NAME}__${element} u-hide" aria-label="${title}">
        <span class="icon icon--sm icon--${svg}">
          <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">
            <path d="M6.25 12a.75.75 0 0 1-.51-1.3L8.648 8 5.74 5.3A.75.75 0 1 1 6.76 4.2l3.5 3.25a.75.75 0 0 1 0 1.1l-3.5 3.25a.749.749 0 0 1-.51.2z"></path>
          </svg>
          <span class="u-screen-reader">${title}</span>
        </span>
      </button>
    `;
  }
  if (svg === 'arrow-left') {
    return `
      <button type="button" class="${BLOCK_NAME}__${element} u-hide" aria-label="${title}">
        <span class="icon icon--sm icon--${svg}">
          <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">
            <path d="M9.75 12a.749.749 0 0 1-.51-.2l-3.5-3.25a.75.75 0 0 1 0-1.1l3.5-3.25a.75.75 0 0 1 1.02 1.1L7.352 8l2.908 2.7a.75.75 0 0 1-.51 1.3z"/>
          </svg>
          <span class="u-screen-reader">${title}</span>
        </span>
      </button>
    `;
  }
  return `
    <button type="button" class="${BLOCK_NAME}__${element} u-hide" aria-label="${title}">
      <span class="icon icon--sm icon--${svg}">
        <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-${svg}"></use>
        </svg>
        <span class="u-screen-reader">${title}</span>
      </span>
    </button>
  `;
}
//



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/slick/arrow.js